// Crosstalk store: line each dropdown's link column up under its top-level menu item (Chris 2026-10-19).
// Horizon's mega menu always starts the links at the page margin. This shifts the list with a CSS variable,
// clamped so it never runs into the featured products on the right. Desktop only (the drawer is untouched).
(() => {
  const align = (item) => {
    const link = item.querySelector(':scope > a, :scope > .menu-list__link, a');
    const grid = item.querySelector('.mega-menu__grid');
    const list = item.querySelector('.mega-menu__list');
    if (!link || !grid || !list || window.innerWidth < 990) return;
    const g = grid.getBoundingClientRect();
    let offset = link.getBoundingClientRect().left - g.left;
    const content = grid.querySelector('.mega-menu__content');
    // The list element spans most of the grid, so measure the widest link instead.
    const linkW = Math.max(0, ...[...list.querySelectorAll('.mega-menu__link')].map((a) => a.getBoundingClientRect().width));
    const limit = (content ? content.getBoundingClientRect().left : g.right) - g.left - linkW - 24;
    offset = Math.max(0, Math.min(offset, limit));
    grid.style.setProperty('--ct-submenu-offset', `${Math.round(offset)}px`);
  };
  const bind = () => document.querySelectorAll('.menu-list__list-item').forEach((item) => {
    if (!item.querySelector('.menu-list__submenu') || item.dataset.ctAlign) return;
    item.dataset.ctAlign = '1';
    ['pointerenter', 'focusin'].forEach((e) => item.addEventListener(e, () => requestAnimationFrame(() => align(item))));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();

// Crosstalk Mobile links open in a new window: the "Networking" menu item, the drawer copy, and any other link on the page (Chris 2026-10-22).
// Shopify menus have no target setting, so it's done here.
(() => {
  const mark = () => document.querySelectorAll('a[href*="crosstalkmobile.com"]').forEach((a) => {
    a.target = '_blank';
    a.rel = 'noopener';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  // The mobile drawer and some menus render late, so mark again before any click lands.
  document.addEventListener('pointerdown', mark, { capture: true });
})();
